import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledActionButton = styled(Button)`
  margin-bottom: 1rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 50%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;
  }
`;

export const StyledButtonWithTooltipWrapper = styled.div`
  display: flex;

  > button {
    width: 100%;
  }
`;
